import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import {
  fetchCanUserCreateRequest,
  TCanUserCreateRequestResponse,
} from 'shared/repositories/newbuilding-broker/v1/can-user-create-request';
import { IApplicationContext } from 'shared/types/applicationContext';

const STATUS_ERROR = 'Некорректный статус при получении доступности бронирования объявки';

export const canMakeNewbuildingBrokerRequest = async (context: IApplicationContext): Promise<boolean> => {
  const { httpApi, logger } = context;

  try {
    const response: TCanUserCreateRequestResponse = await fetchCanUserCreateRequest({
      httpApi,
    });

    if (response.statusCode !== 200) {
      throw new HttpBadStatusCodeError(response.response?.message ?? STATUS_ERROR, response.statusCode);
    }

    return response.response.canCreate;
  } catch (error) {
    logger.warning(error, {
      domain: 'canMakeNewbuildingBrokerRequest.ts',
      message: 'Ошибка получения доступности бронирования объявки',
    });

    throw error;
  }
};
